import { render, staticRenderFns } from "./UsersKeywords.vue?vue&type=template&id=b02b6e04&scoped=true"
import script from "./UsersKeywords.vue?vue&type=script&lang=js"
export * from "./UsersKeywords.vue?vue&type=script&lang=js"
import style0 from "./UsersKeywords.vue?vue&type=style&index=0&id=b02b6e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02b6e04",
  null
  
)

export default component.exports